import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import { Getter, Mutation } from "vuex-class";

import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import { SolicitacaoController } from "@/assets/ts/controller/SolicitacaoController";
import LoadingController from "@/assets/ts/controller/LoadingController";
import Util from "@/../bower_components/teknisavuecomponents/assets/utils/Util";

@Component({
  name: 'DetalhesSolicitacao',
  components: {
    EditableTable,
  },
})
export default class DetalhesSolicitacao extends Vue {
  // [ PROPS ]
  @Prop({ default: null })
  private nrSolicitacao: string;

  @Prop({ default: null })
  private nmTipoSolicitacao: string;

  @Prop({ default: null })
  private nmVinculo: string;

  @Prop({ default: null })
  private statusSolicitacao: string;

  @Prop({ default: null })
  private dataSolicitacao: string;

  @Prop({ default: null })
  private faseAtualSolicitacao: string;

  @Prop({ default: null })
  private nmSolicitante: string;

  @Prop({ default: null })
  private dsObservacao: string;

  @Prop({ default: false })
  private isVisible: boolean;
  // [ PROPS ]

  // [ DATA ]
  private screen = {
    titleTemplate: 'Detalhes | @',
    title: '',
  };

  private actions = {
    close: this.close,
    save: () => {},
    saveDisabled: false,
  }

  private tab = 0;

  private readonly tabs = {
    ITENS_SOLICITACAO: {
      tab: 0,
      icon: 'mdi-format-list-bulleted',
      description: 'Itens',
      gridGetDataAction: this.getItensSolicitacao,
      disabled: false,
      grid: {
        actions: [],
        columns: [
          {
            text: 'Nr. Item',
            value: 'NRITEMSOLICITACAO',
            type: 'text',
          },
          {
            text: 'Descrição do Item',
            value: 'DSLABELITEMSOLI',
            type: 'text',
          },
          {
            text: 'Valor do Item',
            value: 'DSVALORITEMSOLI',
            type: 'text',
          },
        ],
        dense: false,
        loading: false,
        tableReadonly: true,
        reloadOnCreation: true,
        rows: [],
        toolbarActions: [
          {
            name: 'reload',
            label: 'Atualizar',
            icon: 'mdi-refresh',
            onClick: this.reloadGridTab,
          },
        ],
        rowsOnUpdate: () => {},
      }
    },
    FASES_APROVACAO: {
      tab: 1,
      icon: 'mdi-list-status',
      description: 'Fases Aprovação',
      gridGetDataAction: this.getFasesSolicitacao,
      disabled: false,
      grid: {
        actions: [],
        columns: [
          {
            text: 'Ordem',
            value: 'NRORDEM',
            type: 'text',
          },
          {
            text: 'Fase',
            value: 'NMFASEAPROVSOLI',
            type: 'text',
          },
          {
            text: 'Status',
            value: 'DSAPROVADO',
            type: 'text',
          },
          {
            text: 'Responsável',
            value: 'NMOPERADOR',
            type: 'text',
          },
          {
            text: 'Aprovado em',
            value: 'DTINCLUSAO',
            type: 'text',
          },
          {
            text: 'Observação',
            value: 'DSOBSERVACAO',
            type: 'text',
          },
        ],
        dense: false,
        loading: false,
        tableReadonly: true,
        reloadOnCreation: true,
        rows: [],
        toolbarActions: [
          {
            name: 'reload',
            label: 'Atualizar',
            icon: 'mdi-refresh',
            onClick: this.reloadGridTab,
          },
        ],
        rowsOnUpdate: () => {},
      }
    },
  };

  private async reloadGridTab() {
    const currentTab = this.currentTab;
    if (Util.isEmptyOrBlank(currentTab)) {
      return;
    }

    const currentGrid = this.currentTab.grid;

    currentGrid.loading = true;
    try {
      currentGrid.rows = await currentTab.gridGetDataAction();
    } catch (err) {
      currentGrid.rows = [];
    } finally {
      currentGrid.loading = false;
    }
  }
  // [ DATA ]

  // [ COMPUTED ]
  private get currentTab(): any {
    return this.getCurrentTab();
  }

  private get currentGrid(): any {
    return this.currentTab.grid;
  }
  
  private get fasesAprovacaoTab(): any {
    return this.tabs.FASES_APROVACAO;
  }

  private get itensSolicitacaoTab(): any {
    return this.tabs.ITENS_SOLICITACAO;
  }

  private get fasesAprovacaoGrid(): any {
    return this.fasesAprovacaoTab.grid;
  }

  private get itensSolicitacaoGrid(): any {
    return this.itensSolicitacaoTab.grid;
  }
  // [ COMPUTED ]

  // [ STORE ]
  @Getter('loadingVisibility')
  private loadingVisibility: boolean;
  
  @Mutation('controlPopUp')
  private controlPopUp: (popUp: {[key: string]: any, popUp: string}) => void;
  // [ STORE ]

  // [ EMIT ]
  @Emit('close-popup')
  private close() {}
  // [ EMIT ]

  // [ METHODS ]
  @Watch('isVisible', { immediate: true, deep: true })
  private isVisibleOnChange(newValue: boolean) {
    if (newValue) {
      this.onShowPopup();
      return;
    }
    this.onHidePopup();
  }

  private onShowPopup() {
    this.updatePopupTile();
    LoadingController.forceHideLoading();
    this.reloadAllGridTabs();
  }

  private onHidePopup() {
    LoadingController.cancelForceHideLoading();
    this.resetTab();
  }

  private getCurrentTab() {
    for (const tabIndex in this.tabs) {
      const currentTab = this.tabs[tabIndex];
      if (currentTab.tab === this.tab) {
        return currentTab;
      }
    }

    return {};
  }

  private async reloadAllGridTabs(): Promise<void> {
    const gridTabs = this.getGridTabs();

    for (const gridTab of gridTabs) {
      const currentGrid = gridTab.grid || {};
      currentGrid.loading = true;
      currentGrid.rows = [];
    }

    for (const gridTab of gridTabs) {
      const currentGrid = gridTab.grid || {};
      try {
        currentGrid.rows = await gridTab.gridGetDataAction();
      } finally {
        currentGrid.loading = false;
      }
    }
  }

  private getGridTabs(): any[] {
    const gridTabs = [];
    for (const tabIndex in this.tabs) {
      const tab = this.tabs[tabIndex];
      if (tab.grid && tab.gridGetDataAction) {
        gridTabs.push(tab);
      }
    }

    return gridTabs;
  }

  private updatePopupTile(): void {
    this.screen.title = this.screen.titleTemplate.replace(
      '@', `${this.nrSolicitacao} - ${this.nmTipoSolicitacao}`
    );
  }

  private async getFasesSolicitacao() {
    return await SolicitacaoController.getFasesSolicitacao(this.nrSolicitacao);
  }

  private async getItensSolicitacao() {
    return await SolicitacaoController.getItemSolicitacao(this.nrSolicitacao);
  }

  private resetTab() {
    this.tab = 0;
  }
  // [ METHODS ]
}